import { useQuery } from '@tanstack/react-query';
import React from 'react';
import BlogRow from './BlogRow';

const Blogs = () => {
    const { data: blogsData = [], isLoading } = useQuery({
        queryKey: ['blog'],
        queryFn: () => fetch(`${process.env.REACT_APP_API_URL}/blogs`)
            .then(res => res.json())
    })
    return (
        <div className='bg-color w-full'>
            <div id='blogs' className='px-5 xl:px-0 max-w-6xl mx-auto bg-color py-11 lg:py-20'>
                <div class="mt-6 md:flex md:items-center md:justify-between">
                    <div>
                        <h1 class="text-3xl font-semibold text-gray-800 capitalize lg:text-4xl dark:text-white">
                            Latest News
                        </h1>
                        <p className='text-gray-500 pt-2'>Discover Your Perfect Program in Our Courses.</p>
                    </div>

                    <div class="mt-5 md:mt-0">
                        <h3 className='text-lg  cursor-pointer'>Browse All <i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-7 my-8'>
                    {
                        blogsData.map(blog =>
                            <BlogRow
                                key={blog._id}
                                blog={blog}
                            />
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Blogs;